var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-input-select',_vm._b({model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'data-input-select',_vm.inputBind,false))
}
var staticRenderFns = []

export { render, staticRenderFns }